import { createPortal } from "react-dom"
import Button from "./Button"

const SECTIONS = [
  "Abstract",
  "Chapter One",
  "Chapter Two",
  "Chapter Three",
  "Chapter Four",
  "Chapter Five",
  "References",
  "Appendix"
]

const CongratulationsModal = ({ open, projectTitle, onClose, onOpenDocument }) => {
  if (!open) return null

  return createPortal(
    <dialog
      open
      className="modal fixed inset-0 z-[1200] items-start justify-center pt-6 sm:pt-10"
      aria-labelledby="congrats-title"
      aria-modal="true"
    >
      <div className="modal-box max-w-lg overflow-hidden border border-emerald-200/70 bg-white text-slate-900 shadow-2xl">
        <div className="relative">
          <div className="absolute -left-10 -top-10 h-32 w-32 rounded-full bg-emerald-200/30 blur-2xl" />
          <div className="absolute -right-12 -top-12 h-36 w-36 rounded-full bg-cyan-200/30 blur-2xl" />
          <div className="animate-as-pop-in">
            <div className="flex items-start gap-3">
              <div className="mt-0.5 flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-50 ring-1 ring-emerald-200/70">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-7 w-7 text-emerald-700"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
                </svg>
              </div>
              <div className="min-w-0">
                <h3 id="congrats-title" className="text-lg font-extrabold tracking-tight sm:text-xl">
                  Congratulations!
                </h3>
                <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                  You successfully generated your full documentation
                  {projectTitle ? (
                    <>
                      {" "}
                      for <span className="font-semibold text-slate-900">&quot;{projectTitle}&quot;</span>
                    </>
                  ) : null}
                  .
                </p>
              </div>
            </div>

            <div className="mt-4 rounded-2xl border border-slate-200/80 bg-gradient-to-b from-slate-50 to-white p-4">
              <p className="text-[11px] font-bold uppercase tracking-wide text-slate-500">Generated sections</p>
              <ul className="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-2">
                {SECTIONS.map((label) => (
                  <li key={label} className="flex items-center gap-2 rounded-xl bg-white px-3 py-2 ring-1 ring-slate-200/70">
                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-emerald-600 text-[11px] font-bold text-white">
                      ✓
                    </span>
                    <span className="text-sm font-medium text-slate-800">{label}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-5 flex flex-col sm:flex-row gap-2 sm:justify-end">
              <Button variant="outline" onClick={onClose}>
                Close
              </Button>
              <Button onClick={onOpenDocument}>
                Open full document
              </Button>
            </div>
          </div>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop" onClick={onClose}>
        <button>close</button>
      </form>
    </dialog>,
    document.body
  )
}

export default CongratulationsModal

